import React, { useState } from 'react'
import { 
     AppBar, Tab, 
     Tabs, useMediaQuery,
     Toolbar, Typography, useTheme } from '@mui/material'
import { Person } from '@mui/icons-material'
import DrawerComp from './DrawerComp'


const PAGES = ["HOME", "ABOUT", "TESTIMONIALS", "HIRE ME", "CONTACTS", "SERVICES", "BLOG", "LEARN PROGRAMMING"];

const Header = () => {
    const [value, setValue] = useState(0)
    const theme= useTheme();
    const isMatch = useMediaQuery(theme.breakpoints.down('md'));
    
    const handleChange =  (e, v) => setValue(v);

  return (
    <React.Fragment>
        <AppBar sx={{backgroundColor: "#063970"}}>
           <Toolbar>
            <Person fontSize='large'/>
            <Tab label='OUSMANE SANGARY'/>

               {
                isMatch ? (<>
                {/* <Typography sx={{fontSize: '1.5rem', paddingLeft: '10%'}}>
                    {" "}
                    OUSMANE SANGARY
                </Typography> */}
                <DrawerComp />
                </>
                ):

                (<>
              <Tabs 
              sx= {{marginLeft: 'auto'}}
              value={value}
              onChange={handleChange}
              textColor='inherit' 
              indicatorColor='secondary'>

                {
                    PAGES.map((page, index) => {
                        <Tab key={index} label={page} />
                    })
                }
                <Tab label='HOME' href='#'/>
                <Tab label='ABOUT' href='#about'/>
                <Tab label='TESTIMONIALS' href='#testimonial'/>
                <Tab label='HIRE ME' href='#contact'/>
                <Tab label='CONTACTS' href='#contact'/>
                <Tab label='SERVICES' href='#services'/>
              </Tabs>
              {/* <Button sx={{marginLeft: "auto"}} variant='Contained'>SignUp{" "}</Button>
              <Button sx={{}} variant='Contained'>Login{" "}</Button> */}

              </>)}

           </Toolbar>
        </AppBar>
    </React.Fragment>
  )
}

export default Header